import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandHoldingDollar, faWallet, faCreditCard, faArrowUpFromBracket, faCircleNotch, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import Select from "react-select";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { formatCurrency, getRate } from '../utils/currencyUtils';
import { useNavigate, useLocation, Link } from 'react-router-dom'

function RWithdraw1() {
  const { user } = useUser();
  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const lsType = localStorage.getItem('withdraw.type');
    const hasType = state?.type || lsType;
    if (!hasType) {
        navigate('/rwithdraw', { replace: true });
    } else {
        setLoading(false);
    }
  }, [state, navigate]);
  const [error, setError] = useState(false);
  const [symbol, setSymbol] = useState(localStorage.getItem('withdraw.symbol') || '');
  const [price, setPrice] = useState(localStorage.getItem('withdraw.price') || '');
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const usdbal = user?.vested_savings;
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const [crypto, setCrypto] = useState([]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          label: <><img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" /> {coin.symbol}</>,
          value: coin.name,
          amount: 0,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  const [type, setType] = useState(() => {return state?.type ?? localStorage.getItem('withdraw.type') ?? 'Crypto';});
  const [camount, setCamount] = useState(localStorage.getItem('withdraw.camount') || '');
  const [asset, setAsset] = useState(localStorage.getItem('withdraw.asset') || 'BTC');
  const [amount, setAmount] = useState(localStorage.getItem('withdraw.amount') || '');
  const [address, setAddress] = useState(localStorage.getItem('withdraw.address') || '');
  const [paymentDetails, setPaymentDetails] = useState(localStorage.getItem('withdraw.addpaymentDetailsress') || '');
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  function validateAssets (selected){
    setAsset(selected.value)
    setSymbol(selected.symbol)
    setPrice(selected.price)
  }
  function validateAmount (value){
    setAmount(value);
    if((Number(usdbal) * rate) < value || Number(usdbal) === 0){
      setError(true);
    }else{
      setError(false);
    }
  }
  function validateCamount (value){
    setCamount(value);
    if(price){
        if(Number(usdbal) < (value * price) || Number(usdbal) === 0){
            setError(true);
        }else{
            setError(false);
        }
    }else{
        setError(true);
    }
  }
  useEffect(() => {
    if(type && (amount || camount) && (address || paymentDetails) || !error){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [type, amount, camount, error, paymentDetails, address]);
  
  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Deposit" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Deposit" icon={<FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 mb-5">
                        <h5 className="mb-0" style={{fontWeight:'900'}}>Withdraw Funds</h5>
                        <p className="mb-0">Withdraw from from your account</p>
                        <div className="mt-5 d-flex align-items-center progressD" style={{gap:'20px'}}>
                          <Link to="/rwithdraw" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Method Selection</p>
                          </Link>
                          <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/rwithdraw1" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Withdrawal Details</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/rwithdraw2" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faArrowUpFromBracket} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Withdrawal Code</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/rwithdraw3" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Review & Submit</p>
                          </Link>
                        </div>
                        <div className="mycard p-3 mt-4">
                          <div className="row">
                            <div className="col-12">
                              {type == "Crypto" && (
                                <>
                                    <label className="fw-semibold mb-1">Select Crypto to withdraw</label>
                                    <Select 
                                        options={crypto} 
                                        value={crypto.find((opt) => opt.value === asset)}
                                        onChange={(selected) => validateAssets(selected)}
                                        isSearchable
                                        styles={darkThemeStyles}
                                        className="w-full"
                                    />
                                    <hr/>
                                    <label className="fw-semibold mb-1">Amount:</label>
                                    <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 ${error ? 'input-error' : ''}`}>
                                        <input 
                                            type="text" 
                                            placeholder="0.01" 
                                            className="inputNone"
                                            value={camount}
                                            onChange={(e) => validateCamount(e.target.value)}
                                        />
                                        <div className="fw-bold text-white d-flex align-items-center" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}}>
                                        {symbol}
                                        </div>
                                    </div>
                                    {error && (
                                        <p className="mb-0 text-danger fs-7 mt-1">Your current balance is low. Kindly choose a lower amount.</p>
                                    )}
                                    <div className="d-flex align-items-center justify-content-between mt-1">
                                        <p className="mb-0 fs-7 text-white">Current balance:</p>
                                        <p className="mb-0 fs-7 text-success">{((Number(usdbal) / price) * rate).toFixed(5)} {symbol}</p>
                                    </div>
                                    <hr/>
                                    <label className="fw-semibold mb-1">Address:</label>
                                    <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                                        <input 
                                        type="text"
                                        placeholder={`Your ${asset} address`}
                                        className="inputNone w-100 py-1"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        />
                                    </div>
                                    <hr/>
                                </>
                              )}
                              {type != "Crypto" && (
                                <>
                                <label className="fw-semibold mb-1">Amount:</label>
                                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 ${error ? 'input-error' : ''}`}>
                                    <input 
                                        type="text" 
                                        placeholder="1000" 
                                        className="inputNone"
                                        value={amount}
                                        onChange={(e) => validateAmount(e.target.value)}
                                    />
                                    <div className="fw-bold text-white d-flex align-items-center" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}}>
                                    {user?.currency}
                                    </div>
                                </div>
                                {error && (
                                    <p className="mb-0 text-danger fs-7 mt-1">Your current balance is low. Kindly choose a lower amount.</p>
                                )}
                                <div className="d-flex align-items-center justify-content-between mt-1">
                                    <p className="mb-0 fs-7 text-white">Current balance:</p>
                                    <p className="mb-0 fs-7 text-white">{formatCurrency(Number(usdbal) * rate)} {user?.currency}</p>
                                </div>
                                <hr/>
                                </>
                              )}
                              {type == "Bank Transfer" && (
                                <>
                                    <label className="fw-semibold mb-1">Payment Details:</label>
                                    <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                                        <textarea 
                                            placeholder={`Your bank payment details`}
                                            className="inputNone w-100 py-1"
                                            value={paymentDetails}
                                            onChange={(e) => setPaymentDetails(e.target.value)}
                                            rows={4}
                                        />
                                    </div>
                                    <hr/>
                                </>
                              )}
                              <div className="d-flex justify-content-end">
                                {disable ? (
                                    <div className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block disabled">Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></div>
                                ) : (
                                    <Link to="/rwithdraw2" state={{type:type, camount:camount, asset:asset, amount:amount, address:address, paymentDetails:paymentDetails, price:price, symbol:symbol}} className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block" onClick={() => {
                                      localStorage.setItem('withdraw.camount', camount);
                                      localStorage.setItem('withdraw.asset', asset);
                                      localStorage.setItem('withdraw.amount', amount);
                                      localStorage.setItem('withdraw.address', address);
                                      localStorage.setItem('withdraw.paymentDetails', paymentDetails);
                                      localStorage.setItem('withdraw.symbol', symbol);
                                      localStorage.setItem('withdraw.price', price);
                                    }}>Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></Link>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default RWithdraw1